import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, XCircle, Lightbulb } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 bg-slate-900 border-y border-slate-800" data-id="element-236">
      <div className="max-w-5xl mx-auto" data-id="element-237">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-238">
          <div className="inline-flex items-center justify-center p-3 bg-red-500/10 rounded-full mb-6" data-id="element-239">
            <AlertTriangle className="w-8 h-8 text-red-500" data-id="element-240" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-241">
            Por Qué Seguir Dependiendo de Pastillas es Como Ponerle Cinta
            Adhesiva a una Fuga de Agua
          </h2>
          <p className="text-xl text-slate-400 font-medium" data-id="element-242">
            3 REALIDADES QUE NADIE TE DICE:
          </p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-3 mb-12" data-id="element-243">
          {[{
          title: 'Las pastillas no arreglan el problema de raíz',
          desc: 'Solo fuerzan una reacción química temporal. Es como acelerar un motor que ya no tiene gasolina: funciona un rato, pero el daño es inevitable.'
        }, {
          title: "Los 'suplementos naturales' suelen ser placebos caros",
          desc: 'Sin la concentración exacta de ingredientes activos, solo estás orinando dinero. Literalmente.'
        }, {
          title: 'Tu cerebro ya está condicionado al fracaso',
          desc: "Cada vez que dudas '¿funcionará esta vez?', tu cuerpo libera cortisol. Y el cortisol es el enemigo #1 del flujo sanguíneo."
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-slate-950 p-6 rounded-2xl border border-slate-800 flex flex-col items-center text-center" data-id="element-244">
              <XCircle className="w-8 h-8 text-red-500/80 mb-4" data-id="element-245" />
              <h3 className="text-lg font-bold text-slate-200 mb-3" data-id="element-246">
                {item.title}
              </h3>
              <p className="text-slate-400 leading-relaxed text-sm" data-id="element-247">
                {item.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-blue-900/20 border border-blue-500/30 p-8 rounded-2xl relative overflow-hidden" data-id="element-248">
          <div className="absolute top-0 left-0 w-1 h-full bg-blue-500" data-id="element-249"></div>
          <div className="flex flex-col md:flex-row gap-6 items-center md:items-start" data-id="element-250">
            <div className="p-4 bg-blue-500/20 rounded-full shrink-0" data-id="element-251">
              <Lightbulb className="w-8 h-8 text-blue-400" data-id="element-252" />
            </div>
            <div className="text-left" data-id="element-253">
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-254">
                El 90% de los hombres busca en el lugar equivocado.
              </h3>
              <p className="text-slate-300 leading-relaxed mb-3" data-id="element-255">
                No es la testosterona. No es tu "hombría". No es tu edad.
              </p>
              <p className="text-slate-300 leading-relaxed mb-3" data-id="element-256">
                Es una molécula llamada{' '}
                <span className="text-blue-400 font-bold" data-id="element-257">Óxido Nítrico</span>{' '}
                que vive en tus arterias... y está dormida.
              </p>
              <p className="text-white font-semibold leading-relaxed" data-id="element-258">
                Cuando la despiertas, tu cuerpo responde como debería haber
                respondido siempre.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}